import PrimerDidCompleteCheckoutWithData from "../../../../content/sdk/ios/2.x.x/primer/_delegate/primerDidCompleteCheckoutWithData.mdx";
import PrimerDidTokenizePaymentMethod from "../../../../content/sdk/ios/2.x.x/primer/_delegate/primerDidTokenizePaymentMethod.mdx";
import PrimerDidResumeWith from "../../../../content/sdk/ios/2.x.x/primer/_delegate/primerDidResumeWith.mdx";
import PrimerClientSessionWillUpdate from "../../../../content/sdk/ios/2.x.x/primer/_delegate/primerClientSessionWillUpdate.mdx";
import PrimerClientSessionDidUpdate from "../../../../content/sdk/ios/2.x.x/primer/_delegate/primerClientSessionDidUpdate.mdx";
import PrimerWillCreatePaymentWithData from "../../../../content/sdk/ios/2.x.x/primer/_delegate/primerWillCreatePaymentWithData.mdx";
import PrimerDidEnterResumePendingWithPaymentAdditionalInfo from "../../../../content/sdk/ios/2.x.x/primer/_delegate/primerDidEnterResumePendingWithPaymentAdditionalInfo.mdx";
import PrimerDidFailWithError from "../../../../content/sdk/ios/2.x.x/primer/_delegate/primerDidFailWithError.mdx";
import PrimerDidDismiss from "../../../../content/sdk/ios/2.x.x/primer/_delegate/primerDidDismiss.mdx";
import * as React from 'react';
export default {
  PrimerDidCompleteCheckoutWithData,
  PrimerDidTokenizePaymentMethod,
  PrimerDidResumeWith,
  PrimerClientSessionWillUpdate,
  PrimerClientSessionDidUpdate,
  PrimerWillCreatePaymentWithData,
  PrimerDidEnterResumePendingWithPaymentAdditionalInfo,
  PrimerDidFailWithError,
  PrimerDidDismiss,
  React
};